import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { VariedadService } from "../service/variedad.service";
// import { QRCodeModule } from "angularx-qrcode";

export interface Coordinates {
  latitude: number;
  longitude: number;
}
@Component({
  selector: "app-variedad-item",
  templateUrl: "./variedad-item.component.html",
  styleUrls: ["./variedad-item.component.css"],
})
export class VariedadItemComponent implements OnInit {
  @Input() id!: string;
  constructor(private variedadService: VariedadService,

  ) { }
  variedadObs$!: Observable<any>;
  gpsObs$!: Observable<any>;
  myAngularxQrCode!: string | null;
  ngOnInit(): void {
    this.fnObservable(this.id);
  }
  fnObservable(id: string) {
    this.variedadObs$ = this.variedadService.getCatalogInfo(id);
    this.variedadObs$.subscribe(
      (x: any) => {
        if (x.data.has_genotype_data) {
          this.myAngularxQrCode = 'https://wikipapa.org/pages/report/index.php?id=' + this.id
        } else {
          this.myAngularxQrCode = null;
        }
      }
    );
    this.gpsObs$ = this.variedadService.getObservationGps(id);
  }


}
